import React, { useState, useEffect } from "react";
// import IntTotime from "../../common/IntTotime";
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import Blink from "react-blink-tag";
const Card = ({
  list,
  current,
  handleonClick,
  maxperhour,
  showid = 0,
  typeid = 0,
  truckid = 0,
  storeid = 0,
  showtime = false,
  cid = 0,
  showBooking = false,
  showcomplain =false,
  chkbreak = false,
}) => {
  const [state, setState] = useState({ count: 8, title: "stop" });
  const count = state.count;
  const title = state.title;

  useEffect(() => {
    let interval;
    switch (title) {
      case "stop":
        if (count > 0) {
          interval = setInterval(() => {
            setState((prevState) => ({
              ...prevState,
              count: prevState.count - 1,
            }));
          }, 500);

          return () => {
            clearInterval(interval);
          };
        } else {
          clearInterval(interval);
          setState((prevState) => ({ ...prevState, title: "go" }));
        }
        break;
      case "go":
        setTimeout(() => {
          setState((prevState) => ({ ...prevState, title: "ready" }));
        }, 1000);
        break;
      default:
        setTimeout(() => {
          setState((prevState) => ({ ...prevState, title: "stop", count: 8 }));
        }, 1000);
        break;
    }
  }, [count, title]);

  // const BlinkingComponent = ({ highlighting }) => (
  //   <div className={`element${highlighting ? " highlight" : ""}`}>Watch Me</div>
  // );
  // const highlight =true;

  const array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return list.map((item, index) => {
    return (
      <div key={item._id}>
        <div className="row">
          {item && current === item._id ? (
            <div
              style={{ width: 50, height: 30, fontSize: "14px" }}
              className="col-xs-1   bg-primary border border-muted text-white   border-bottom-0 border-right-0"
            >
              <div className="d-flex justify-content-center mt-1">
                {item.queuetime}
                {":00"}
              </div>
              {/* <BlinkingComponent highlighting={highlight} /> */}
            </div>
          ) : (
            <div
              style={{ width: 50, height: 30, fontSize: "14px" }}
              className="col-xs-1  bg-secondary border border-muted text-white   border-bottom-0 border-right-0"
            >
              <div
                className="d-flex justify-content-center mt-1
          "
              >
                {item.queuetime}
                {":00"}
              </div>
            </div>
          )}
          {typeid === 2 && (
            <>
              <span
                className="badge "
                style={{
                  fontSize: "13px",
                  width: 20,
                }}
              >
                <div className="row">
                  <i
                    id={item._id}
                    className={`bi bi-circle-fill text-${
                      item.mc1 === 1 ? "danger" : "success"
                    } `}
                    style={{ fontSize: 10, cursor: "pointer" }}
                  />
                  <h6 style={{ fontSize: 10, cursor: "pointer" }}>L1</h6>
                </div>
              </span>
              <span
                className="badge "
                style={{
                  fontSize: "13px",
                  width: 20,
                }}
              >
                <div className="row">
                  <i
                    id={item._id}
                    className={`bi bi-circle-fill text-${
                      item.mc2 === 1 ? "danger" : "success"
                    } `}
                    style={{ fontSize: 10, cursor: "pointer" }}
                  />
                  <h6 style={{ fontSize: 10, cursor: "pointer" }}>L2</h6>
                </div>
              </span>
            </>
          )}


          {item.breaktime ? (
            <>
              {maxperhour > 0 && (
                <span
                  className="badge  mx-1"
                  style={{
                    fontSize: "13px",
                    cursor: "pointer",
                    background: "#7F8487",
                    width:
                      showid === 1
                        ? maxperhour * 165
                        : showtime
                        ? maxperhour * 127
                        : maxperhour * 107,
                    maxHeight: 40,
                  }}
                >
                  <button
                    type="button"
                    className="btn   btn-sm p-0 "
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={item.remark}
                  >
                    <span className="text-white fw-bold">
                      {" "}
                      break {item.remark}{" "}
                    </span>
                  </button>
                </span>
              )}
            </>
          ) : null}

          {item &&
            item.queue &&
            item.queue.length > 0 &&
            item.queue.map((queue, index) => {
              
              if (
                (queue.status_id === 3 || queue.status_id === 0) &&
                queue.truckno &&
                showBooking === false
              ) {
                return null;
              } else if (
                typeid === 2 &&
                showid === 3 &&
                storeid !== 0 &&
                queue.storename !== storeid
              ) {
                return null;
              } else {
                return (
                  <div
                    key={index}
                    style={{
                      width:
                        showid === 1 || showid === 2 || showid === 3
                          ? 150
                          : showtime
                          ? 120
                          : 100,
                      maxHeight: 40,
                      fontSize: "12px",
                    }}
                    className="m-1  "
                  >
                    { showcomplain ? (
                      queue.chkcompain ? 
                      showid === 1 || showid === 2 || showid === 3 ? (
                        <div
                          className="row d-flex justify-content-center  "
                          id={queue.queue_id}
                        >
                          {queue.status_id === 1 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              queue.totaltime > 120 ? (
                                <span
                                  className="badge bg-success text-dark"
                                  style={{
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    width: 160,
                                  }}
                                  onClick={() =>
                                    handleonClick(
                                      queue.queue_keys_data,
                                      queue.queue_id
                                    )
                                  }
                                >
                                  {showid === 1
                                    ? queue.customername
                                    : showid === 2
                                    ? queue.typename
                                    : queue.storeid === 20 ||
                                      queue.storeid === 23 ||
                                      queue.storeid === 30 ||
                                      queue.storeid === 31
                                    ? "Line1/" + queue.typename
                                    : queue.storeid === 21 ||
                                      queue.storeid === 24 ||
                                      queue.storeid === 32 ||
                                      queue.storeid === 33
                                    ? "Line2/" + queue.typename
                                    : queue.storeid === 19
                                    ? "ลงสต๊อก/" + queue.typename
                                    : "ไม่ระบุ/" + queue.typename}
                                  {showtime ? (
                                    <span
                                      className={`badge  bg-${
                                        queue.totaltime > 240
                                          ? "danger"
                                          : queue.totaltime < 120
                                          ? "success text-dark"
                                          : "warning"
                                      } p-0`}
                                      style={{ fontSize: "8px" }}
                                    >
                                      {/* {IntTotime(queue.totaltime)} */}
                                    </span>
                                  ) : null}
                                </span>
                              ) : (
                                <span
                                  className="badge bg-success text-dark"
                                  style={{
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    width: 160,
                                  }}
                                  onClick={() =>
                                    handleonClick(
                                      queue.queue_keys_data,
                                      queue.queue_id
                                    )
                                  }
                                >
                                  {showid === 1
                                    ? queue.customername
                                    : showid === 2
                                    ? queue.typename
                                    : queue.storeid === 20 ||
                                      queue.storeid === 23 ||
                                      queue.storeid === 30 ||
                                      queue.storeid === 31
                                    ? "Line1/" + queue.typename
                                    : queue.storeid === 21 ||
                                      queue.storeid === 24 ||
                                      queue.storeid === 32 ||
                                      queue.storeid === 33
                                    ? "Line2/" + queue.typename
                                    : queue.storeid === 19
                                    ? "ลงสต๊อก/" + queue.typename
                                    : "ไม่ระบุ/" + queue.typename}
                                  {showtime ? (
                                    <span
                                      className={`badge  bg-${
                                        queue.totaltime > 240
                                          ? "danger"
                                          : queue.totaltime < 120
                                          ? "success text-dark"
                                          : "warning"
                                      } p-0`}
                                      style={{ fontSize: "8px" }}
                                    >
                                      {/* {IntTotime(queue.totaltime)} */}
                                    </span>
                                  ) : null}
                                </span>
                              )
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: 160,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : queue.status_id === 2 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              <span
                                className={`${
                                  queue.queue_no >= 41 && queue.queue_no <= 45
                                    ? "badge  border-pink border border-2"
                                    : "badge "
                                }`}
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  background: "#4E6C50",
                                  width: 160,
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {showid === 1
                                  ? queue.customername
                                  : showid === 2
                                  ? queue.typename
                                  : queue.storeid === 20 ||
                                    queue.storeid === 23 ||
                                    queue.storeid === 30 ||
                                    queue.storeid === 31
                                  ? "Line1/" + queue.typename
                                  : queue.storeid === 21 ||
                                    queue.storeid === 24 ||
                                    queue.storeid === 32 ||
                                    queue.storeid === 33
                                  ? "Line2/" + queue.typename
                                  : queue.storeid === 19
                                  ? "ลงสต๊อก/" + queue.typename
                                  : "ไม่ระบุ/" + queue.typename}
                                {showtime ? (
                                  <span
                                    className={`badge  bg-${
                                      queue.totaltime > 240
                                        ? "danger"
                                        : queue.totaltime < 120
                                        ? "success text-dark"
                                        : "warning"
                                    } p-0`}
                                    style={{ fontSize: "8px" }}
                                  >
                                    {/* {IntTotime(queue.totaltime)} */}
                                  </span>
                                ) : null}
                              </span>
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: 160,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : queue.status_id === 3 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              <span
                                className={`badge ${
                                  queue.truckno &&
                                  queue.Old_driven_no === null &&
                                  queue.arrivaltime === "" &&
                                  showBooking
                                    ? "bg-info"
                                    : queue.truckno &&
                                      queue.Old_driven_no === null &&
                                      showBooking
                                    ? "bg-purple"
                                    : queue.truckno
                                    ? "text-dark p-0"
                                    : "bg-danger"
                                } `}
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: 160,
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {queue.truckno && showBooking === false ? (
                                  <i className="bi bi-truck text-primary  fs-4 "></i>
                                ) : queue.truckno ? (
                                  showid === 1 ? (
                                    queue.customername
                                  ) : showid === 2 ? (
                                    queue.typename
                                  ) : queue.storeid === 20 ||
                                    queue.storeid === 23 ||
                                    queue.storeid === 30 ||
                                    queue.storeid === 31 ? (
                                    "Line1/" + queue.typename
                                  ) : queue.storeid === 21 ||
                                    queue.storeid === 24 ||
                                    queue.storeid === 32 ||
                                    queue.storeid === 33 ? (
                                    "Line2/" + queue.typename
                                  ) : queue.storeid === 19 ? (
                                    "ลงสต๊อก/" + queue.typename
                                  ) : (
                                    "ไม่ระบุ/" + queue.typename
                                  )
                                ) : showid === 1 ? (
                                  queue.customername
                                ) : showid === 2 ? (
                                  queue.typename
                                ) : queue.storeid === 20 ||
                                  queue.storeid === 23 ||
                                  queue.storeid === 30 ||
                                  queue.storeid === 31 ? (
                                  "Line1/" + queue.typename
                                ) : queue.storeid === 21 ||
                                  queue.storeid === 24 ||
                                  queue.storeid === 32 ||
                                  queue.storeid === 33 ? (
                                  "Line2/" + queue.typename
                                ) : queue.storeid === 19 ? (
                                  "ลงสต๊อก/" + queue.typename
                                ) : (
                                  "ไม่ระบุ/" + queue.typename
                                )}
                              </span>
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: 160,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : queue.status_id === 4 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              <span
                                className="badge bg-secondary"
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  width: 160,
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {showid === 1
                                  ? queue.customername
                                  : showid === 2
                                  ? queue.typename
                                  : queue.storeid === 20 ||
                                    queue.storeid === 23 ||
                                    queue.storeid === 30 ||
                                    queue.storeid === 31
                                  ? "Line1/" + queue.typename
                                  : queue.storeid === 21 ||
                                    queue.storeid === 24 ||
                                    queue.storeid === 32 ||
                                    queue.storeid === 33
                                  ? "Line2/" + queue.typename
                                  : queue.storeid === 19
                                  ? "ลงสต๊อก/" + queue.typename
                                  : "ไม่ระบุ/" + queue.typename}
                              </span>
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: 160,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className={`badge ${
                                queue.truckno &&
                                queue.Old_driven_no === null &&
                                queue.arrivaltime === "" &&
                                showBooking
                                  ? "bg-info"
                                  : queue.truckno &&
                                    queue.Old_driven_no === null &&
                                    showBooking
                                  ? "bg-purple"
                                  : queue.truckno
                                  ? "text-dark mx-2  p-0"
                                  : "bg-warning text-dark"
                              } `}
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                background: "#EDE4E0",
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {queue.truckno && showBooking === false ? (
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              ) : queue.truckno ? (
                                showid === 1 ? (
                                  queue.customername
                                ) : showid === 2 ? (
                                  queue.typename
                                ) : queue.storeid === 20 ||
                                  queue.storeid === 23 ||
                                  queue.storeid === 30 ||
                                  queue.storeid === 31 ? (
                                  "Line1/" + queue.typename
                                ) : queue.storeid === 21 ||
                                  queue.storeid === 24 ||
                                  queue.storeid === 32 ||
                                  queue.storeid === 33 ? (
                                  "Line2/" + queue.typename
                                ) : queue.storeid === 19 ? (
                                  "ลงสต๊อก/" + queue.typename
                                ) : (
                                  "ไม่ระบุ/" + queue.typename
                                )
                              ) : showid === 1 ? (
                                queue.customername
                              ) : showid === 2 ? (
                                queue.typename
                              ) : queue.storeid === 20 ||
                                queue.storeid === 23 ||
                                queue.storeid === 30 ||
                                queue.storeid === 31 ? (
                                "Line1/" + queue.typename
                              ) : queue.storeid === 21 ||
                                queue.storeid === 24 ||
                                queue.storeid === 32 ||
                                queue.storeid === 33 ? (
                                "Line2/" + queue.typename
                              ) : queue.storeid === 19 ? (
                                "ลงสต๊อก/" + queue.typename
                              ) : (
                                "ไม่ระบุ/" + queue.typename
                              )}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: 160,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )}
                        </div>
                      ) : (
                        <div
                          className="row d-flex justify-content-center  "
                          id={queue.queue_id}
                        >
                          {queue.status_id === 1 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              queue.totaltime > 120 && count % 2 === 1 ? (
                                <span
                                  className={`badge ${ queue.queue_no >= 41 && queue.queue_no <= 45 
                                     && queue.Old_driven_no &&  queue.Old_driven_no !== queue.queue_driven_no ?
                                      "bg-success1 text-dark  border-pink border border-2" :
                                      queue.Old_driven_no && queue.Old_driven_no !== queue.queue_driven_no ? "badge bg-success1 text-dark border " :
                                      queue.queue_no >= 41 && queue.queue_no <= 45 ? "badge bg-success text-dark  border-pink border border-2":
                                      "bg-success text-dark border border"
                                    
                                    }   ${
                                    queue.totaltime > 240
                                      ? "border-danger border-2 "
                                      : "border-warning border-3 "
                                  }`}
                                  style={{ fontSize: "13px", cursor: "pointer" }}
                                  onClick={() =>
                                    handleonClick(
                                      queue.queue_keys_data,
                                      queue.queue_id
                                    )
                                  }
                                >
                                  
                                  {queue.remark ? (
                                    <div className="position-relative">
                                      <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                        <i
                                          className="bi bi-circle-fill text-warning "
                                          style={{ fontSize: "10px" }}
                                        />
                                      </div>
                                      <div className="d-flex justify-content-center ">
                               
                                      </div>
                                    </div>
                                  ) : null}
                                  {queue.queue_driven_no}{" "}
                                  {queue.queue_driven_prov}{" "}
                                  {showtime ? (
                                    <span
                                      className={`badge  bg-${
                                        queue.totaltime > 240
                                          ? "danger"
                                          : queue.totaltime < 120
                                          ? "primary"
                                          : "warning"
                                      } p-0`}
                                      style={{ fontSize: "9px" }}
                                    >
                                      {/* {IntTotime(queue.totaltime)} */}
                                    </span>
                                  ) : null}
                                </span>
                              ) : (
                                <span
                                  // className={`badge  bg-${
                                  //   queue.totaltime > 240
                                  //     ? "danger"
                                  //     : queue.totaltime < 120
                                  //     ? "primary"
                                  //     : "warning"
                                  // } p-0`}
                                  // : queue.queue_no >= 41 && queue.queue_no <=45 ?
                                  //     "border-end-0 border-start-0  border border-success border border-2 bg-danger text-dark"
                                  className={`${
                                      queue.queue_no >= 41 && queue.queue_no <= 45  && queue.Old_driven_no &&  queue.Old_driven_no !== queue.queue_driven_no
                                      ? "badge bg-success1 text-dark  border-pink border border-2"
                                      : queue.Old_driven_no && queue.Old_driven_no !== queue.queue_driven_no ? "badge bg-success1 text-dark"
                                      :queue.queue_no >= 41 && queue.queue_no <= 45 ? "badge bg-success text-dark  border-pink border border-2"
                                      : "badge bg-success text-dark"
                                  }`}
                                  style={{ fontSize: "13px", cursor: "pointer" }}
                                  onClick={() =>
                                    handleonClick(
                                      queue.queue_keys_data,
                                      queue.queue_id
                                    )
                                  }
                                >
                                  
                                  {queue.remark ? (
                                    <div className="position-relative">
                                      <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                        <i
                                          className="bi bi-circle-fill text-warning "
                                          style={{ fontSize: "10px" }}
                                        />
                                      </div>
                                      <div className="d-flex justify-content-center ">
                                    
                                      </div>
                                    </div>
                                  ) : null}
                                  {queue.queue_driven_no}{" "}
                                  {queue.queue_driven_prov}{" "}
                                  {showtime ? (
                                    <span
                                      className={`badge  bg-${
                                        queue.totaltime > 240
                                          ? "danger"
                                          : queue.totaltime < 120
                                          ? "primary"
                                          : "warning"
                                      } p-0`}
                                      style={{ fontSize: "9px" }}
                                    >
                                      {/* {IntTotime(queue.totaltime)} */}
                                    </span>
                                  ) : null}
                                </span>
                              )
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: showtime ? 120 : 100,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : queue.status_id === 2 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              <span
                                className={`" " ${  queue.queue_no >= 41 && queue.queue_no <= 45? "badge border border-pink border border-2": "badge"}`}                                                
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  background: "#4E6C50",
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {queue.remark ? (
                                  <div className="position-relative">
                                    <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                      <i
                                        className="bi bi-circle-fill text-warning "
                                        style={{ fontSize: "10px" }}
                                      />
                                    </div>
                                    <div className="d-flex justify-content-center ">
                                 
                                    </div>
                                  </div>
                                ) : null}
                                {queue.queue_driven_no} {queue.queue_driven_prov}{" "}
                                {showtime ? (
                                  <span
                                    className={`badge  bg-${
                                      queue.totaltime > 240
                                        ? "danger"
                                        : queue.totaltime < 120
                                        ? "success text-dark"
                                        : "warning"
                                    } p-0`}
                                    style={{ fontSize: "9px" }}
                                  >
                                    {/* {IntTotime(queue.totaltime)} */}
                                  </span>
                                ) : null}
                              </span>
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: showtime ? 120 : 100,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : queue.status_id === 3 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              <span
                                className={`badge ${
                                  queue.truckno &&
                                  queue.Old_driven_no === null &&
                                  queue.arrivaltime === "" &&
                                  showBooking
                                    ? "bg-info"
                                    : queue.truckno &&
                                      queue.Old_driven_no === null &&
                                      showBooking
                                    ? "bg-purple"
                                    : queue.truckno
                                    ? "text-dark p-0"
                                    : queue.queue_no >= 41 && queue.queue_no <= 45
                                    ? "  border border-success border border-2 bg-danger text-dark"
                                    : "bg-danger"
                                } `}
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: showtime ? 120 : 120,
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {queue.remark ? (
                                  <div className="position-relative">
                                    <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                      <i
                                        className="bi bi-circle-fill text-primary "
                                        style={{ fontSize: "10px" }}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                                {queue.truckno && showBooking === false ? (
                                  <i className="bi bi-truck text-primary  fs-4 "></i>
                                ) : queue.truckno &&
                                  queue.Old_driven_no === null ? (
                                  queue.queue_second_no +
                                  " " +
                                  queue.queue_second_prov
                                ) : (
                                  queue.queue_driven_no +
                                  " " +
                                  queue.queue_driven_prov
                                )}
                              </span>
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: showtime ? 120 : 100,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : queue.status_id === 4 ? (
                            cid === 0 || "c" + cid === queue.groupid ? (
                              <span
                                className="badge bg-secondary"
                                style={{ fontSize: "13px", cursor: "pointer" }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {queue.remark ? (
                                  <div className="position-relative">
                                    <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                      <i
                                        className="bi bi-circle-fill text-primary "
                                        style={{ fontSize: "10px" }}
                                      />
                                    </div>
                                    <div className="d-flex justify-content-center ">
                         
                                    </div>
                                  </div>
                                ) : null}
                                {queue.queue_driven_no} {queue.queue_driven_prov}
                              </span>
                            ) : (
                              <span
                                className="badge text-dark mx-1 m-1 p-0"
                                style={{
                                  cursor: "pointer",
                                  background: "#EDE4E0",
                                  width: showtime ? 120 : 100,
                                  maxHeight: 40,
                                }}
                              >
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              </span>
                            )
                          ) : cid === 0 || "c" + cid === queue.groupid ? (
                            // <div className="position-relative">
                            // <div className="position-absolute top-0 start-50 translate-middle mx-1">
                            //   <i
                            //     className="bi bi-circle-fill text-primary "
                            //     style={{ fontSize: "10px" }}
                            //   />
                            // </div>
  
                            <span
                              className={`badge ${
                                queue.truckno &&
                                queue.Old_driven_no === null &&
                                queue.arrivaltime === "" &&
                                showBooking
                                  ? "bg-info"
                                  : queue.truckno &&
                                    queue.Old_driven_no === null &&
                                    showBooking
                                  ? "bg-purple"
                                  : queue.truckno
                                  ? "text-dark mx-2  p-0"
                                  : queue.queue_no >= 41 && queue.queue_no <= 45
                                  ? "border border-pink border border-2 bg-warning text-dark"
                                  : "bg-warning text-dark"
                              } `}
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 100,
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {queue.remark ? (
                                <div className="position-relative">
                                  <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                    <i
                                      className="bi bi-circle-fill text-primary "
                                      style={{ fontSize: "10px" }}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-center ">
                           
                                  </div>
                                </div>
                              ) : null}
  
                              {queue.truckno && showBooking === false ? (
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              ) : queue.truckno &&
                                queue.Old_driven_no === null ? (
                                queue.queue_second_no +
                                " " +
                                queue.queue_second_prov
                              ) : (
                                queue.queue_driven_no +
                                " " +
                                queue.queue_driven_prov
                              )}
                            </span>
  
                            // </div>
  
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 100,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )}
                          {/* <div className="d-flex justify-content-center ">
                            <ReactTooltip
                              anchorId={queue.queue_id}
                              place="top"
                              content={queue.queue_id}
                              variant="info"
                              html={
                                <>
                                  <h6 className="text-white mt-1 m-0">
                                    {item.empname}
                                  </h6>
                                  <span style={{ fontSize: "13px" }}>
                                    {queue.productname}
                                  </span>
                                </>
                              }
                            />
                          </div> */}
                        </div>
                      )
                      
                      :""
                    )
                    
                    :
                    
                    showid === 1 || showid === 2 || showid === 3 ? (
                      <div
                        className="row d-flex justify-content-center  "
                        id={queue.queue_id}
                      >
                        {queue.status_id === 1 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            queue.totaltime > 120 ? (
                              <span
                                className="badge bg-success text-dark"
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  width: 160,
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {showid === 1
                                  ? queue.customername
                                  : showid === 2
                                  ? queue.typename
                                  : queue.storeid === 20 ||
                                    queue.storeid === 23 ||
                                    queue.storeid === 30 ||
                                    queue.storeid === 31
                                  ? "Line1/" + queue.typename
                                  : queue.storeid === 21 ||
                                    queue.storeid === 24 ||
                                    queue.storeid === 32 ||
                                    queue.storeid === 33
                                  ? "Line2/" + queue.typename
                                  : queue.storeid === 19
                                  ? "ลงสต๊อก/" + queue.typename
                                  : "ไม่ระบุ/" + queue.typename}
                                {showtime ? (
                                  <span
                                    className={`badge  bg-${
                                      queue.totaltime > 240
                                        ? "danger"
                                        : queue.totaltime < 120
                                        ? "success text-dark"
                                        : "warning"
                                    } p-0`}
                                    style={{ fontSize: "8px" }}
                                  >
                                    {/* {IntTotime(queue.totaltime)} */}
                                  </span>
                                ) : null}
                              </span>
                            ) : (
                              <span
                                className="badge bg-success text-dark"
                                style={{
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  width: 160,
                                }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                {showid === 1
                                  ? queue.customername
                                  : showid === 2
                                  ? queue.typename
                                  : queue.storeid === 20 ||
                                    queue.storeid === 23 ||
                                    queue.storeid === 30 ||
                                    queue.storeid === 31
                                  ? "Line1/" + queue.typename
                                  : queue.storeid === 21 ||
                                    queue.storeid === 24 ||
                                    queue.storeid === 32 ||
                                    queue.storeid === 33
                                  ? "Line2/" + queue.typename
                                  : queue.storeid === 19
                                  ? "ลงสต๊อก/" + queue.typename
                                  : "ไม่ระบุ/" + queue.typename}
                                {showtime ? (
                                  <span
                                    className={`badge  bg-${
                                      queue.totaltime > 240
                                        ? "danger"
                                        : queue.totaltime < 120
                                        ? "success text-dark"
                                        : "warning"
                                    } p-0`}
                                    style={{ fontSize: "8px" }}
                                  >
                                    {/* {IntTotime(queue.totaltime)} */}
                                  </span>
                                ) : null}
                              </span>
                            )
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: 160,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : queue.status_id === 2 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className={`${
                                queue.queue_no >= 41 && queue.queue_no <= 45
                                  ? "badge  border-pink border border-2"
                                  : "badge "
                              }`}
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                background: "#4E6C50",
                                width: 160,
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {showid === 1
                                ? queue.customername
                                : showid === 2
                                ? queue.typename
                                : queue.storeid === 20 ||
                                  queue.storeid === 23 ||
                                  queue.storeid === 30 ||
                                  queue.storeid === 31
                                ? "Line1/" + queue.typename
                                : queue.storeid === 21 ||
                                  queue.storeid === 24 ||
                                  queue.storeid === 32 ||
                                  queue.storeid === 33
                                ? "Line2/" + queue.typename
                                : queue.storeid === 19
                                ? "ลงสต๊อก/" + queue.typename
                                : "ไม่ระบุ/" + queue.typename}
                              {showtime ? (
                                <span
                                  className={`badge  bg-${
                                    queue.totaltime > 240
                                      ? "danger"
                                      : queue.totaltime < 120
                                      ? "success text-dark"
                                      : "warning"
                                  } p-0`}
                                  style={{ fontSize: "8px" }}
                                >
                                  {/* {IntTotime(queue.totaltime)} */}
                                </span>
                              ) : null}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: 160,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : queue.status_id === 3 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className={`badge ${
                                queue.truckno &&
                                queue.Old_driven_no === null &&
                                queue.arrivaltime === "" &&
                                showBooking
                                  ? "bg-info"
                                  : queue.truckno &&
                                    queue.Old_driven_no === null &&
                                    showBooking
                                  ? "bg-purple"
                                  : queue.truckno
                                  ? "text-dark p-0"
                                  : "bg-danger"
                              } `}
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: 160,
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {queue.truckno && showBooking === false ? (
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              ) : queue.truckno ? (
                                showid === 1 ? (
                                  queue.customername
                                ) : showid === 2 ? (
                                  queue.typename
                                ) : queue.storeid === 20 ||
                                  queue.storeid === 23 ||
                                  queue.storeid === 30 ||
                                  queue.storeid === 31 ? (
                                  "Line1/" + queue.typename
                                ) : queue.storeid === 21 ||
                                  queue.storeid === 24 ||
                                  queue.storeid === 32 ||
                                  queue.storeid === 33 ? (
                                  "Line2/" + queue.typename
                                ) : queue.storeid === 19 ? (
                                  "ลงสต๊อก/" + queue.typename
                                ) : (
                                  "ไม่ระบุ/" + queue.typename
                                )
                              ) : showid === 1 ? (
                                queue.customername
                              ) : showid === 2 ? (
                                queue.typename
                              ) : queue.storeid === 20 ||
                                queue.storeid === 23 ||
                                queue.storeid === 30 ||
                                queue.storeid === 31 ? (
                                "Line1/" + queue.typename
                              ) : queue.storeid === 21 ||
                                queue.storeid === 24 ||
                                queue.storeid === 32 ||
                                queue.storeid === 33 ? (
                                "Line2/" + queue.typename
                              ) : queue.storeid === 19 ? (
                                "ลงสต๊อก/" + queue.typename
                              ) : (
                                "ไม่ระบุ/" + queue.typename
                              )}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: 160,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : queue.status_id === 4 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className="badge bg-secondary"
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                width: 160,
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {showid === 1
                                ? queue.customername
                                : showid === 2
                                ? queue.typename
                                : queue.storeid === 20 ||
                                  queue.storeid === 23 ||
                                  queue.storeid === 30 ||
                                  queue.storeid === 31
                                ? "Line1/" + queue.typename
                                : queue.storeid === 21 ||
                                  queue.storeid === 24 ||
                                  queue.storeid === 32 ||
                                  queue.storeid === 33
                                ? "Line2/" + queue.typename
                                : queue.storeid === 19
                                ? "ลงสต๊อก/" + queue.typename
                                : "ไม่ระบุ/" + queue.typename}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: 160,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : cid === 0 || "c" + cid === queue.groupid ? (
                          <span
                            className={`badge ${
                              queue.truckno &&
                              queue.Old_driven_no === null &&
                              queue.arrivaltime === "" &&
                              showBooking
                                ? "bg-info"
                                : queue.truckno &&
                                  queue.Old_driven_no === null &&
                                  showBooking
                                ? "bg-purple"
                                : queue.truckno
                                ? "text-dark mx-2  p-0"
                                : "bg-warning text-dark"
                            } `}
                            style={{
                              fontSize: "13px",
                              cursor: "pointer",
                              background: "#EDE4E0",
                            }}
                            onClick={() =>
                              handleonClick(
                                queue.queue_keys_data,
                                queue.queue_id
                              )
                            }
                          >
                            {queue.truckno && showBooking === false ? (
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            ) : queue.truckno ? (
                              showid === 1 ? (
                                queue.customername
                              ) : showid === 2 ? (
                                queue.typename
                              ) : queue.storeid === 20 ||
                                queue.storeid === 23 ||
                                queue.storeid === 30 ||
                                queue.storeid === 31 ? (
                                "Line1/" + queue.typename
                              ) : queue.storeid === 21 ||
                                queue.storeid === 24 ||
                                queue.storeid === 32 ||
                                queue.storeid === 33 ? (
                                "Line2/" + queue.typename
                              ) : queue.storeid === 19 ? (
                                "ลงสต๊อก/" + queue.typename
                              ) : (
                                "ไม่ระบุ/" + queue.typename
                              )
                            ) : showid === 1 ? (
                              queue.customername
                            ) : showid === 2 ? (
                              queue.typename
                            ) : queue.storeid === 20 ||
                              queue.storeid === 23 ||
                              queue.storeid === 30 ||
                              queue.storeid === 31 ? (
                              "Line1/" + queue.typename
                            ) : queue.storeid === 21 ||
                              queue.storeid === 24 ||
                              queue.storeid === 32 ||
                              queue.storeid === 33 ? (
                              "Line2/" + queue.typename
                            ) : queue.storeid === 19 ? (
                              "ลงสต๊อก/" + queue.typename
                            ) : (
                              "ไม่ระบุ/" + queue.typename
                            )}
                          </span>
                        ) : (
                          <span
                            className="badge text-dark mx-1 m-1 p-0"
                            style={{
                              cursor: "pointer",
                              background: "#EDE4E0",
                              width: 160,
                              maxHeight: 40,
                            }}
                          >
                            <i className="bi bi-truck text-primary  fs-4 "></i>
                          </span>
                        )}
                      </div>
                    ) : (
                      <div
                        className="row d-flex justify-content-center  "
                        id={queue.queue_id}
                      >
                        {queue.status_id === 1 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            queue.totaltime > 120 && count % 2 === 1 ? (
                              <span
                                className={`badge ${ queue.queue_no >= 41 && queue.queue_no <= 45 
                                   && queue.Old_driven_no &&  queue.Old_driven_no !== queue.queue_driven_no ?
                                    "bg-success1 text-dark  border-pink border border-2" :
                                    queue.Old_driven_no && queue.Old_driven_no !== queue.queue_driven_no ? "badge bg-success1 text-dark border " :
                                    queue.queue_no >= 41 && queue.queue_no <= 45 ? "badge bg-success text-dark  border-pink border border-2":
                                    "bg-success text-dark border border"
                                  
                                  }   ${
                                  queue.totaltime > 240
                                    ? "border-danger border-2 "
                                    : "border-warning border-3 "
                                }`}
                                style={{ fontSize: "13px", cursor: "pointer" }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                
                                {queue.remark ? (
                                  <div className="position-relative">
                                    <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                      <i
                                        className="bi bi-circle-fill text-warning "
                                        style={{ fontSize: "10px" }}
                                      />
                                    </div>
                                    <div className="d-flex justify-content-center ">
                               
                                    </div>
                                  </div>
                                ) : null}
                                {queue.queue_driven_no}{" "}
                                {queue.queue_driven_prov}{" "}
                                {showtime ? (
                                  <span
                                    className={`badge  bg-${
                                      queue.totaltime > 240
                                        ? "danger"
                                        : queue.totaltime < 120
                                        ? "primary"
                                        : "warning"
                                    } p-0`}
                                    style={{ fontSize: "9px" }}
                                  >
                                    {/* {IntTotime(queue.totaltime)} */}
                                  </span>
                                ) : null}
                              </span>
                            ) : (
                              <span
                                // className={`badge  bg-${
                                //   queue.totaltime > 240
                                //     ? "danger"
                                //     : queue.totaltime < 120
                                //     ? "primary"
                                //     : "warning"
                                // } p-0`}
                                // : queue.queue_no >= 41 && queue.queue_no <=45 ?
                                //     "border-end-0 border-start-0  border border-success border border-2 bg-danger text-dark"
                                className={`${
                                    queue.queue_no >= 41 && queue.queue_no <= 45  && queue.Old_driven_no &&  queue.Old_driven_no !== queue.queue_driven_no
                                    ? "badge bg-success1 text-dark  border-pink border border-2"
                                    : queue.Old_driven_no && queue.Old_driven_no !== queue.queue_driven_no ? "badge bg-success1 text-dark"
                                    :queue.queue_no >= 41 && queue.queue_no <= 45 ? "badge bg-success text-dark  border-pink border border-2"
                                    : "badge bg-success text-dark"
                                }`}
                                style={{ fontSize: "13px", cursor: "pointer" }}
                                onClick={() =>
                                  handleonClick(
                                    queue.queue_keys_data,
                                    queue.queue_id
                                  )
                                }
                              >
                                
                                {queue.remark ? (
                                  <div className="position-relative">
                                    <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                      <i
                                        className="bi bi-circle-fill text-warning "
                                        style={{ fontSize: "10px" }}
                                      />
                                    </div>
                                    <div className="d-flex justify-content-center ">
                            
                                    </div>
                                  </div>
                                ) : null}
                                {queue.queue_driven_no}{" "}
                                {queue.queue_driven_prov}{" "}
                                {showtime ? (
                                  <span
                                    className={`badge  bg-${
                                      queue.totaltime > 240
                                        ? "danger"
                                        : queue.totaltime < 120
                                        ? "primary"
                                        : "warning"
                                    } p-0`}
                                    style={{ fontSize: "9px" }}
                                  >
                                    {/* {IntTotime(queue.totaltime)} */}
                                  </span>
                                ) : null}
                              </span>
                            )
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 100,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : queue.status_id === 2 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className={`" " ${  queue.queue_no >= 41 && queue.queue_no <= 45? "badge border border-pink border border-2": "badge"}`}                                                
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                background: "#4E6C50",
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {queue.remark ? (
                                <div className="position-relative">
                                  <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                    <i
                                      className="bi bi-circle-fill text-warning "
                                      style={{ fontSize: "10px" }}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-center ">
                         
                                  </div>
                                </div>
                              ) : null}
                              {queue.queue_driven_no} {queue.queue_driven_prov}{" "}
                              {showtime ? (
                                <span
                                  className={`badge  bg-${
                                    queue.totaltime > 240
                                      ? "danger"
                                      : queue.totaltime < 120
                                      ? "success text-dark"
                                      : "warning"
                                  } p-0`}
                                  style={{ fontSize: "9px" }}
                                >
                                  {/* {IntTotime(queue.totaltime)} */}
                                </span>
                              ) : null}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 100,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : queue.status_id === 3 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className={`badge ${
                                queue.truckno &&
                                queue.Old_driven_no === null &&
                                queue.arrivaltime === "" &&
                                showBooking
                                  ? "bg-info"
                                  : queue.truckno &&
                                    queue.Old_driven_no === null &&
                                    showBooking
                                  ? "bg-purple"
                                  : queue.truckno
                                  ? "text-dark p-0"
                                  : queue.queue_no >= 41 && queue.queue_no <= 45
                                  ? "  border border-success border border-2 bg-danger text-dark"
                                  : "bg-danger"
                              } `}
                              style={{
                                fontSize: "13px",
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 120,
                              }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {queue.remark ? (
                                <div className="position-relative">
                                  <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                    <i
                                      className="bi bi-circle-fill text-primary "
                                      style={{ fontSize: "10px" }}
                                    />
                                  </div>
                                </div>
                              ) : null}
                              {queue.truckno && showBooking === false ? (
                                <i className="bi bi-truck text-primary  fs-4 "></i>
                              ) : queue.truckno &&
                                queue.Old_driven_no === null ? (
                                queue.queue_second_no +
                                " " +
                                queue.queue_second_prov
                              ) : (
                                queue.queue_driven_no +
                                " " +
                                queue.queue_driven_prov
                              )}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 100,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : queue.status_id === 4 ? (
                          cid === 0 || "c" + cid === queue.groupid ? (
                            <span
                              className="badge bg-secondary"
                              style={{ fontSize: "13px", cursor: "pointer" }}
                              onClick={() =>
                                handleonClick(
                                  queue.queue_keys_data,
                                  queue.queue_id
                                )
                              }
                            >
                              {queue.remark ? (
                                <div className="position-relative">
                                  <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                    <i
                                      className="bi bi-circle-fill text-primary "
                                      style={{ fontSize: "10px" }}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-center ">
                     
                                  </div>
                                </div>
                              ) : null}
                              {queue.queue_driven_no} {queue.queue_driven_prov}
                            </span>
                          ) : (
                            <span
                              className="badge text-dark mx-1 m-1 p-0"
                              style={{
                                cursor: "pointer",
                                background: "#EDE4E0",
                                width: showtime ? 120 : 100,
                                maxHeight: 40,
                              }}
                            >
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            </span>
                          )
                        ) : cid === 0 || "c" + cid === queue.groupid ? (
                          // <div className="position-relative">
                          // <div className="position-absolute top-0 start-50 translate-middle mx-1">
                          //   <i
                          //     className="bi bi-circle-fill text-primary "
                          //     style={{ fontSize: "10px" }}
                          //   />
                          // </div>

                          <span
                            className={`badge ${
                              queue.truckno &&
                              queue.Old_driven_no === null &&
                              queue.arrivaltime === "" &&
                              showBooking
                                ? "bg-info"
                                : queue.truckno &&
                                  queue.Old_driven_no === null &&
                                  showBooking
                                ? "bg-purple"
                                : queue.truckno
                                ? "text-dark mx-2  p-0"
                                : queue.queue_no >= 41 && queue.queue_no <= 45
                                ? "border border-pink border border-2 bg-warning text-dark"
                                : "bg-warning text-dark"
                            } `}
                            style={{
                              fontSize: "13px",
                              cursor: "pointer",
                              background: "#EDE4E0",
                              width: showtime ? 120 : 100,
                            }}
                            onClick={() =>
                              handleonClick(
                                queue.queue_keys_data,
                                queue.queue_id
                              )
                            }
                          >
                            {queue.remark ? (
                              <div className="position-relative">
                                <div className="position-absolute top-0 start-100 translate-middle mx-1">
                                  <i
                                    className="bi bi-circle-fill text-primary "
                                    style={{ fontSize: "10px" }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center ">
                       
                                </div>
                              </div>
                            ) : null}

                            {queue.truckno && showBooking === false ? (
                              <i className="bi bi-truck text-primary  fs-4 "></i>
                            ) : queue.truckno &&
                              queue.Old_driven_no === null ? (
                              queue.queue_second_no +
                              " " +
                              queue.queue_second_prov
                            ) : (
                              queue.queue_driven_no +
                              " " +
                              queue.queue_driven_prov
                            )}
                          </span>

                          // </div>

                        ) : (
                          <span
                            className="badge text-dark mx-1 m-1 p-0"
                            style={{
                              cursor: "pointer",
                              background: "#EDE4E0",
                              width: showtime ? 120 : 100,
                              maxHeight: 40,
                            }}
                          >
                            <i className="bi bi-truck text-primary  fs-4 "></i>
                          </span>
                        )}
                        {/* <div className="d-flex justify-content-center ">
                          <ReactTooltip
                            anchorId={queue.queue_id}
                            place="top"
                            content={queue.queue_id}
                            variant="info"
                            html={
                              <>
                                <h6 className="text-white mt-1 m-0">
                                  {item.empname}
                                </h6>
                                <span style={{ fontSize: "13px" }}>
                                  {queue.productname}
                                </span>
                              </>
                            }
                          />
                        </div> */}
                      </div>
                    )
                    }
                  </div>
                );
              }
            })}

          {typeid === 2
            ? item.breaktime
              ? null
              : array &&
                array.length > 0 &&
                array.map((item1, index1) => {
                  // console.log(item1, index1)
                  // if ( chkbreak  ) {
                  //   return null;
                  // }
                  // else

                  if (
                    item1 + item.queue.length <=
                    (truckid === 1
                      ? item.custid1
                      : truckid === 2
                      ? item.custid3
                      : item.custid1 + item.custid3)
                  ) {
                    return (
                      <span
                        key={index1}
                        className="badge text-dark mx-1 m-1 p-0"
                        style={{
                          cursor: "pointer",
                          background: "#EDE4E0",
                          width: showid === 1 ? 150 : showtime ? 120 : 100,
                          maxHeight: 40,
                        }}
                      >
                        <i className="bi bi-truck text-danger  fs-4 "></i>
                      </span>
                    );
                  } else if  (item1 + item.queue.length <=
                     (maxperhour) && (truckid === 1
                        ? item.custid1
  
                        : truckid === 2
                        ? item.custid3
                        : item.custid1 + item.custid3) < maxperhour ) {
                        return (
                          <span
                            key={index1}
                            className="badge text-dark mx-1 m-1 p-0 d-flex align-items-center justify-content-center"
                            style={{
                              // cursor: "pointer",
                              background: "#B2B2B2",
                              width: showid === 1 ? 150 : showtime ? 120 : 100,
                              maxHeight: 30,
                            }}
                          >
                            <span    style={{ fontSize: "13px"}}>
                            Limit
                            </span>
                          
                            {/* <i className="bi bi-truck text-danger  fs-4 "></i> */}
                          </span>
                        );
                      }else
                      
                      {
                    return null;
                  }
                })
            : item.breaktime
            ? null
            : array &&
              array.length > 0 &&
              array.map((item1, index1) => {
                // if ( chkbreak  ) {
                //   return null;
                // }
                // else
                if (item1 + item.queue.length <= maxperhour) {
                  return (
                    <span
                      key={index1}
                      className="badge text-dark mx-1 m-1 p-0"
                      style={{
                        cursor: "pointer",
                        background: "#EDE4E0",
                        width: showid === 1 ? 150 : showtime ? 120 : 100,
                        maxHeight: 40,
                      }}
                    >
                      <i className="bi bi-truck text-danger  fs-4 "></i>
                    </span>
                  );
                } else {
                  return null;
                }
              })}
        </div>
      </div>
    );
  });
};

export default Card;
